import { DocumentNode, gql } from '@apollo/client'

export const GET_EXPORT_DATA: DocumentNode = gql`
    query GetExportData(
        $daycareIds: [Int]
        $from: Date
        $to: Date
        $type: ExportDataType
        $sectionIds: [Int]
        $eventId: Int
        $mealTypes: [MealType]
    ) {
        getExportData(
            daycareIds: $daycareIds
            from: $from
            to: $to
            type: $type
            sectionIds: $sectionIds
            eventId: $eventId
            mealTypes: $mealTypes
        ) {
            type
            base64Data
        }
    }
`

export const REPRINT_DAYCARE_REPORT: DocumentNode = gql`
    mutation reprintDaycareReport($daycareIds: [Int], $from: Date, $to: Date, $fromGroup: Boolean) {
        reprintDaycareReport(daycareIds: $daycareIds, from: $from, to: $to, fromGroup: $fromGroup)
    }
`
